<p-dialog styleClass="!border-0" header="Loading" [draggable]="false" [closable]="false" [modal]="true" [visible]="visible$()" [resizable]="false" [closeOnEscape]="false">
  <ng-template #headless>
      <div class="w-[50px] h-[50px] m-6">
        <p-progress-spinner ariaLabel="loading" styleClass="w-[50px] h-[50px]" strokeWidth="4" />
      </div>
  </ng-template>
</p-dialog>
